import ErrorPage from '@ac/components/ErrorPage';

const Home = () => (
  <ErrorPage titleKey="account_center.home.title" messageKey="account_center.home.description" />
);

export default Home;
